<template>
  <div>
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="main">
        <div class="swiper">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="item in img">
              <img :src="item.img_url" alt="" width="100%" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="card">
          <div class="card-detail">
            <div style="float: left">
              <h2 class="pri">￥{{ sku.price }}</h2>
              <h4 class="name">{{ goodsTitle }}</h4>
            </div>
            <p style="float: right; color: #9e9e9e">已售卖{{ sell_num }}件</p>
          </div>
        </div>
        <div class="content">
          <p style="margin-left: 0.75rem; color: #000; font-weight: 700">
            商品详情
          </p>
          <p class="goods-detail" v-html="detail"></p>
        </div>
      </div>
    </van-pull-refresh>

    <div class="footer">
      <div class="left">
        <div class="kf">
          <van-icon name="chat-o" size="18" />
          <p class="one">客服</p>
        </div>
        <div class="sc" v-if="!isCollect" @click="collect(false)">
          <van-icon name="star-o" size="18" />
          <p class="two">收藏</p>
        </div>
        <div class="sc" v-else @click="collect(true)">
          <van-icon name="star" color="#ee0a24" size="18" />
          <p class="two">已收藏</p>
        </div>
      </div>
      <div class="right">
        <p class="buy" @click="show = true">立即购买</p>
        <van-sku
          v-model="show"
          :sku="sku"
          :goods="goods"
          :show-add-cart-btn="false"
          :quota="quota"
          :disable-stepper-input="true"
          :close-on-click-overlay="true"
          :custom-stepper-config="customStepperConfig"
          @buy-clicked="onBuyClicked2"
          @sku-selected="selectSku"
          @open-preview="openPreview"
          ref="getSkuData"
          id="goodssku"
          @stepper-change="changeNum"
        >
          <template #sku-header="props">
            <div class="van-sku-header van-hairline--bottom">
              <div class="van-image van-sku-header__img-wrap">
                <img
                  @click="imgPre(goods.picture)"
                  :src="goods.picture"
                  class="van-image__img"
                  style="object-fit: cover"
                />
              </div>
              <div class="van-sku-header__goods-info">
                <div class="van-sku__goods-price">
                  <span class="van-sku__price-symbol">￥</span
                  ><span class="van-sku__price-num">{{
                    IntegerToFloat(goodsPrice * value)
                  }}</span>
                </div>
                <div class="van-sku-header-item">
                  <span class="van-sku__stock"
                    >剩余
                    <span class="van-sku__stock-num">{{ sku.stock_num }}</span>
                    件</span
                  >
                </div>
                <div class="van-sku-header-item">
                  已选 <span> {{ Object.values(giftName).join(" ") }} </span>
                </div>
              </div>
            </div>
          </template>
          <template #sku-group="props">
            <div class="van-sku-group-container">
              <div
                class="van-sku-row van-hairline--bottom"
                v-for="item in sku.tree"
              >
                <div class="van-sku-row__title">{{ item.title }}</div>
                <span
                  class="van-sku-row__item"
                  :class="{
                    active: Object.values(giftName).includes(it.gift_name),
                  }"
                  v-for="(it, i) in item.item"
                >
                  <div
                    v-if="it.stock !== 0"
                    @click="changeSp(it.gift_name, item.title, it.img)"
                    class="van-sku-row__item-name"
                  >
                    {{ it.gift_name }}
                  </div>
                  <div
                    v-else
                    class="van-sku-row__item-name"
                    style="color: #ccc"
                  >
                    <p class="quehuo">缺货</p>
                    {{ it.gift_name }}
                  </div>
                </span>
              </div>
            </div>
          </template>

          <template #sku-actions="props">
            <div class="van-sku-actions">
              <van-button
                class="btn-buy"
                block
                size="large"
                color="#670000"
                @click="onBuyClicked2(props)"
              >
                立即支付
                <span>￥</span>
                <span style="font-size: 1.1rem">
                  {{ IntegerToFloat(goodsPrice * value) }}
                </span>
              </van-button>
            </div>
          </template>
        </van-sku>
      </div>
    </div>

    <Back-top :height="300">
      <img src="../../assets/icons/return_top.png" alt="" />
    </Back-top>
  </div>
</template>
<script>
import $ from "jquery";
import { ImagePreview } from "vant";
import api from "../Api";
export default {
  mixins: [api],
  components: {},
  data() {
    return {
      title: "",
      giftName: {}, // 商品规格
      goodsPrice: 0, // 商品价格
      goodsTitle: "",
      img: [],
      detail: "",
      show: false,
      sell_num: "",
      goods: {
        picture: "",
      },
      choosePicture: "",
      itemIds: [],
      //商品id
      id: this.$route.params.id,
      value: 1, // 购买数量
      sku: {
        tree: [],
        // 所有 sku 的组合列表，如下是：白色1、白色2、天蓝色1、天蓝色2
        list: [],
        price: "",
        stock_num: 0, // 商品总库存
        none_sku: false, // 是否无规格商品
        hide_stock: false, // 是否隐藏剩余库存
      },
      //商品类型 1、秒杀礼包 2、日常礼包，3、预约礼包
      goods_type: "0",
      //限购1个
      quota: 1,
      limit: 0,
      stock: 0,
      customStepperConfig: {
        quotaText: "",
      },
      showButton: false,
      isCollect: false,
    };
  },
  mounted() {
    this.getshopitems();
  },
  methods: {
    collect(flag) {
      var api = flag ? "/shop/new-goods-un-collect" : "/shop/new-goods-collect";
      this.$Ajax(api, {
        goodsId: this.$route.params.id,
      }).then((rs) => {
        if (rs.code == 200) {
          this.isCollect = !this.isCollect;
        }
      });
    },
    getshopitems() {
      this.$Ajax("shop/new-goods-detail", {
        goodsId: this.$route.params.id,
      }).then((rs) => {
        this.title = rs.data.goods_content;
        this.detail = rs.data.goods_detail;
        this.stock = rs.data.stock;

        this.limit = rs.data.limit;

        this.isCollect = rs.data.collectFlag;
        //限购
        if (rs.data.describe != "") {
          this.quota = Number(rs.data.deadline_num);
          this.customStepperConfig.quotaText = rs.data.describe;
        } else {
          this.quota = Number(rs.data.limit);
          this.customStepperConfig.quotaText = "限购" + this.quota + "件";
        }
        this.sell_num = rs.data.sell_num;
        this.img = rs.data.goods_img;
        this.goodsTitle = rs.data.goods_name;
        this.sku.tree = rs.data.group;
        this.sku.list = rs.data.group[0].item;

        // console.log(this.sku1);
        this.hGoods();
        // 默认商品 sku 缩略图
        this.goods.picture = rs.data.group[0].item[0].img;
        //官方文档中price的单位为分  需要乘以100
        // for (var i = 0; i < this.sku.list.length; i++) {
        //   this.sku.list[i].price = Number(this.sku.list[i].price * 100);
        // }
        //库存
        this.sku.stock_num = Number(rs.data.stock);

        //商品类型
        this.goods_type = rs.data.goods_type;

        //价格
        if (rs.data.minPrice == rs.data.maxPrice) {
          return (this.sku.price = rs.data.minPrice);
        } else {
          return (this.sku.price = rs.data.minPrice + "~" + rs.data.maxPrice);
        }
      });
    },

    // 选择商品规格
    changeSp(name, title, img) {
      // console.log(title);
      if (Object.values(this.giftName).includes(name)) return;
      this.giftName[title] = name;
      this.goods.picture = img;
      // console.log(this.giftName);
      // this.goodsPrice = this.goodsPrice + Number(price)
      this.goodsPrice = 0;
      this.itemIds = [];
      var that = this;
      this.sku.tree.forEach((it) => {
        it.item.forEach((t) => {
          if (Object.values(that.giftName).includes(t.gift_name)) {
            that.goodsPrice = that.goodsPrice + t.price * 1;
            that.itemIds.push(t.id);
          }
        });
      });
      this.$store.commit(
        "setBuyInfo",
        JSON.stringify({
          ...this.giftName,
        })
      );
      this.$store.commit("setBuyPrice", this.goodsPrice);
    },
    // 默认选中商品
    hGoods() {
      var that = this;
      this.sku.tree.forEach((item) => {
        this.giftName[item.title] = item.item[0].gift_name;
      });
      this.sku.tree.forEach((it) => {
        it.item.forEach((t) => {
          if (Object.values(that.giftName).includes(t.gift_name)) {
            that.goodsPrice = that.goodsPrice + Number(t.price);
            that.itemIds.push(t.id);
            // stockNum.push(t.stock)
          }
        });
        // console.log(this.itemIds);
      });
      this.$store.commit(
        "setBuyInfo",
        JSON.stringify({
          ...this.giftName,
        })
      );
      this.$store.commit("setBuyPrice", this.goodsPrice);
    },
    imgPre(img) {
      ImagePreview([img]);
    },

    changeNum(value) {
      // console.log(value);
      this.value = value;
    },

    IntegerToFloat(value) {
      value = Math.floor(value * 100) / 100;
      const q = value.toString().split(".");
      // console.log(q);
      if (!value.toString().includes(".")) {
        return value + ".00";
      } else if (q[1].length === 1) {
        return value + "0";
      } else {
        return value;
      }
    },

    openPreview(data) {
      if (this.choosePicture != "") {
        this.goods.picture = this.choosePicture;
      }
    },
    selectSku() {
      var key = this.$refs.getSkuData.selectedSku;
      var list = this.sku.list;
      var keyLength = JSON.stringify(key).length;
      // console.log(keyLength);

      for (var a in list) {
        if (
          JSON.stringify(key).slice(0, keyLength - 1) ==
          JSON.stringify(list[a]).slice(0, keyLength - 1)
        ) {
          //console.log(list[a]);

          $(".van-sku-header__img-wrap img").attr("src", list[a].imgUrl);
          this.choosePicture = list[a].imgUrl;
        }
      }
    },

    onBuyClicked2(data) {
      //选择完规格后的sku的id
      var skuId = this.itemIds.join(",");
      // console.log(data.selectedNum);
      var goodsid = this.id;
      if (this.sku.stock_num) {
        this.$router.push({
          name: "shop.subOrder",
          query: {
            id: goodsid,
            skuId: skuId,
            num: data.selectedNum,
            game_id: this.$route.query.game_id,
          },
        });
      } else {
        this.$toast("此商品暂无库存");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.van-sku-header__goods-info {
  text-align: left;
}

span.active:before {
  color: #670000;
  background-color: #ecd7d5 !important;
  font-size: 0.7rem;
}

.header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.main {
  background-color: #f2f2f2;
  margin-top: 2.5rem;
  margin-bottom: 3.95rem;
}

.card {
  padding: 0.65rem 0.75rem 0.55rem;
}

.card-detail {
  padding: 0.9rem 0.5rem 1rem;
  height: 4.45rem;
  border-radius: 0.7rem;
  background-color: #ffffff;

  .pri {
    color: #670000;
    margin-bottom: 0.5rem;
    font-size: 0.8rem;
  }

  .name {
    color: #000000;
    font-size: 0.7rem;
  }
}

:deep(img) {
  // width: 18.75rem;
}

.van-address-item {
  margin: 0.7rem 0.75rem;
  width: 17.25rem;
  height: 4.5rem;
  padding: 0.95rem 0.5rem 0.9rem;

  .van-address-item__tag {
    margin-left: 0.3rem;
    background-color: #ecd7d5;
    color: #670000;
    border-radius: 0.2rem;
    font-size: 0.6rem;
    padding: 0.1rem;
  }

  .van-address-item__address {
    width: 10.4rem;
    height: 1.6rem;
    margin-top: 0.35rem;
    color: #656565;
  }
}

:deep(.van-address-list__bottom) {
  margin: 0 0.75rem 1.15rem;
  width: 17.25rem;
  height: 2.3rem;

  .van-address-list__add {
    height: 2.3rem;
    background-color: #670000;
  }
}

.container {
  display: flex;
  flex-direction: column;
}

.comain {
  flex: 1;
  overflow: auto;
}

:deep(.van-sku-row) {
  text-align: left;
}

.footer {
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  position: fixed;
  background-color: #ffffff;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3.95rem;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0.45rem 1.05rem;

  .left {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    text-align: center;
    color: #9e9e9e;

    .kf {
      margin-right: 2.2rem;
    }

    .sc {
      width: 2.2rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  .right {
    width: 50%;
    text-align: center;

    .buy {
      float: right;
      width: 5.5rem;
      height: 1.7rem;
      line-height: 1.7rem;
      border-radius: 1.25rem;
      color: #ffffff;
      background-color: #670000;
    }
  }

  :deep(.van-hairline--bottom::after) {
    border-bottom-width: 0;
  }

  .btn-buy {
    margin: 0.55rem 0.75rem 1.1rem;
    border-radius: 1.25rem;
    height: 2.3rem;
  }

  .van-popup--bottom {
    background-color: rgba(243, 242, 242, 1);
  }

  :deep(.van-image__img) {
    width: 100%;
    height: 100%;
  }

  :deep(.van-sku-row__item-name) {
    color: rgba(0, 0, 0, 1);
  }

  :deep(.van-sku-row__item::before) {
    background-color: rgba(243, 242, 242, 1);
  }

  .van-sku-row__item.active {
    background-color: rgba(236, 215, 213, 1);

    .van-sku-row__item-name {
      color: #670000;
    }
  }

  :deep(.van-sku-body) {
    margin: 0 0.75rem;
    border-radius: 0.7rem 0.7rem 0 0;
    background-color: rgba(255, 255, 255, 1);
    /* display: flex;
    flex-direction: column;
    justify-content: space-evenly; */
  }

  :deep(.van-sku-row__title) {
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
  }

  :deep(.van-sku-messages) {
    display: none;
  }

  .van-sku-actions {
    box-shadow: 0 0.15rem 0.3rem 0.05rem rgba(0, 0, 0, 0.16);
    padding: 0;
  }
}

.back-to-top {
  position: fixed;
  bottom: 5.8rem;
  right: 1rem;
  width: 2.4rem;
  height: 2rem;
  border-radius: 0.2rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  border: none;
  cursor: pointer;
}

/deep/.goods-detail {
  padding: 0 0.75rem;

  img {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
